import { LineChartOutlined } from '@ant-design/icons';
import {
  actionConstants,
  appConstants,
  resourceConstants,
} from 'constants/index';
import { ADHOC_PATH, PURCHASING_PATHS } from 'constants/paths';
import { permission } from 'helpers/common';
import configHelpers from 'helpers/config';
import { t } from 'helpers/i18n';
import { getSrc } from 'helpers/url';
import { IRoute } from 'interfaces';
import { lazy } from 'react';
import flagConstants from 'constants/flagsup';

const { STAFF_BFF } = appConstants;
const {
  SGC_MMS,
  SKU_RELATIONS,
  RETURN_OMV2_ORDER,
  ADHOC_TOOLS,
} = resourceConstants;
const { EXTENDED_FLAG_KEYS } = flagConstants;
const {
  READ_BARCODE_CHANGE,
  READ_BARCODE_FAIL_SYNCED,
  READ_SKU_TYPE_CHANGE,
  READ_SKU_INACTIVE,
  READ,
  UPDATE,
  CREATE,
  READ_VOUCHER_OFFLINE,
} = actionConstants;

const {
  baseSupplyChainUrl,
  baseErpUrl,
  baseNewWmsUrl,
} = configHelpers.getCommonConfig();
const IFrameContainer = lazy(() => import('containers/shared/IFrameContainer'));

const iFramePages = [
  {
    exportType: 'sgc_mms_barcode_change',
    name: t('UpdatedUPCDataReport'),
    permissions: [permission(STAFF_BFF, SGC_MMS, READ_BARCODE_CHANGE)],
  },
  {
    exportType: 'sgc_mms_barcode_fail_synced',
    name: t('FailedUPCSyncList'),
    permissions: [permission(STAFF_BFF, SGC_MMS, READ_BARCODE_FAIL_SYNCED)],
  },
  {
    exportType: 'sgc_mms_sku_type_change',
    name: t('UpdatedItemGroupData'),
    permissions: [permission(STAFF_BFF, SGC_MMS, READ_SKU_TYPE_CHANGE)],
  },
  {
    exportType: 'sgc_mms_sku_inactive',
    name: t('ProductLockStatusChange'),
    permissions: [permission(STAFF_BFF, SGC_MMS, READ_SKU_INACTIVE)],
  },
];

const iFrameSetCodePages = [
  {
    path: '/sgc-tools/config-setcode',
    name: t('ConfigSetcodeManagement'),
    permissions: [permission(STAFF_BFF, SKU_RELATIONS, READ)],
  },
  {
    path: '/sgc-tools/config-setcode/update',
    name: t('UpdateConfigSetcode'),
    permissions: [permission(STAFF_BFF, SKU_RELATIONS, UPDATE)],
    hidden: true,
  },
];

const sgcToolRoutes: IRoute[] = [
  {
    path: '/sgc-tools',
    name: t('AdhocTool.Root'),
    icon: LineChartOutlined,
    children: [
      ...iFramePages.map(page => `/sgc-tools/${page.exportType}`),
      ...iFrameSetCodePages.filter(page => !page.hidden).map(page => page.path),
      '/adhoc-tools/return-omv2-order',
      '/adhoc-tools/voucher-offline',
    ],
  },
  ...iFramePages.map(({ exportType, name, permissions }) => ({
    exact: true,
    path: `/sgc-tools/${exportType}`,
    name,
    component: IFrameContainer,
    iFrameSrc: getSrc(
      baseSupplyChainUrl,
      `${PURCHASING_PATHS.ExportHistoryStatic}/${exportType}`
    ),
    permissions,
    hideBackButton: true,
  })),
  ...iFrameSetCodePages.map(({ path, name, permissions }) => ({
    exact: true,
    path: path,
    name,
    component: IFrameContainer,
    iFrameSrc: getSrc(baseErpUrl, path),
    permissions,
    hideBackButton: true,
    flagKey: EXTENDED_FLAG_KEYS.ENABLE_SETCODE_CONFIG.key,
  })),
  {
    exact: true,
    path: '/adhoc-tools/return-omv2-order',
    iFrameSrc: getSrc(baseNewWmsUrl, ADHOC_PATH.ReturnOMv2Order),
    name: t('Warehousing.ReturnOmv2Order'),
    component: IFrameContainer,
    permissions: [permission(STAFF_BFF, RETURN_OMV2_ORDER, CREATE)],
    hideSellerSwitch: true,
    hidePlatformSwitch: true,
  },
  {
    exact: true,
    path: '/adhoc-tools/voucher-offline',
    iFrameSrc: getSrc(baseErpUrl, ADHOC_PATH.VoucherOffline),
    name: t('AdhocTool.VoucherOffline'),
    component: IFrameContainer,
    permissions: [permission(STAFF_BFF, ADHOC_TOOLS, READ_VOUCHER_OFFLINE)],
  },
];

export default sgcToolRoutes;
